import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ViewNotificacao from './ViewNotificacao.vue';
import EnviarNotificacao from './components/EnviarNotificacao.vue';

export default {
  path: '/admin',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'notificacao', path: 'notificacao', component: ViewNotificacao },
    { name: 'criaNotificacao', path: 'criaNotificacao', component: EnviarNotificacao },
  ],
};
